// src/disableConsole.js

if (process.env.REACT_APP_NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.error = noop;
  console.info = noop;
}
